import Icon from '../components/Icon.vue'

Icon.register({
  'user-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 288C335.5 288 400 223.5 400 144S335.5 0 256 0 112 64.5 112 144 176.5 288 256 288zM384 320H328.9C306.7 330.2 282 336 256 336S205.4 330.2 183.1 320H128C57.3 320 0 377.3 0 448V464C0 490.5 21.5 512 48 512H464C490.5 512 512 490.5 512 464V448C512 377.3 454.7 320 384 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-alt.js
// module id = nVpw
// module chunks = 144